export default {
  template: {
    title: '候选人问卷管理',
    menu: '候选人问卷管理',
    taskTitle: '模板更新任务管理'
  },
  label: {
    group: '模板',
    groupName: '模板名称',
    questionType: '问题类型',
    questionTitle: '问题',
    includeKnockoutOptions: '包含淘汰选项',
    createUpdateTask: '创建更新任务',
    options: '选项',
    allOptions: '全部选项',
    markAsKnockoutOptions: '标记为淘汰项',
    unGrouped: '未分组',
    duration: '视频长度限制',
    visibility: '可见性',
    templateName: '模板名称',
    updateJobs: '更新的职位',
    executeTime: '预计开始时间',
    executeStatus: '状态',
    finishTime: '完成时间',
    noJobs: '无',
    taskStatus: {
      pending: '待执行',
      executing: '执行中',
      success: '执行成功',
      failure: '执行失败'
    },
    status: '状态',
    otherGroup: '———————— 未分组 ————————'
  },
  editor: {
    group: {
      title: {
        add: '添加模板',
        edit: '编辑模板'
      }
    },
    question: {
      title: {
        add: '添加问题',
        edit: '编辑问题'
      }
    }
  },
  questionType: {
    TEXT: '问答题',
    SELECT: '单选题',
    CHECKBOX: '多选题',
    VIDEO: '视频题',
    ATTACHMENT: '附件题',
    SINGLE_SELECT: '下拉单选题',
    MULTIPLE_SELECT: '下拉多选题',
    DATE: '日期题'
  },
  btn: {
    addGroup: '添加模板',
    addQuestion: '添加问题',
    addNewGroup: '添加模板',
    addNewQuestion: '添加问题',
    moveQuestion: '移动到',
    taskList: '任务列表',
    back: '返回',
    addQuestionFromTemplate: '从模板中添加',
    questionOptions: {
      expand: '显示选项',
      collapse: '隐藏选项'
    }
  },
  placeholder: {
    questionTypeFilter: '选择问题类型',
    groupFilter: '选择模板',
    groupQuestionKeywordsFilter: '按照问题进行搜索',
    options: '选项1\n选项2\n选项3\n...等',
    markAsKnockoutOptions: '选择淘汰项'
  },
  message: {
    notKnockoutOptionsTip: '填写答题选项，或者直接从Excel中复制。',
    knockoutOptionsTip: '当候选人回答了淘汰选项后会被系统自动标记状态为不合格。',
    executeTime: '该执行时间为预估时间，实际执行以系统内任务排队情况为准，一般会在执行时间开始后10分钟内完成。',
    duplicateTitle: '问题重复，请检查修改后重新提交。',
    confirmEnable: {
      disable: '确定禁用？',
      enable: '确定激活？'
    }
  },
  visibilityType: {
    IE: '内外部可见',
    I: '仅内部可见',
    E: '仅外部可见'
  }
}
